import { gql } from '@apollo/client'

export const myPendingAdvisorInvitations = gql`
  query myPendingAdvisorInvitations {
    myPendingAdvisorInvitations {
      id
      flowType
      donorName
      createdAt
      expiresAt
    }
  }
`

export const myDonorAdvisorInvites = gql`
  query myDonorAdvisorInvites($fundId: Int) {
    myDonorAdvisorInvites(fundId: $fundId) {
      id
      flowType
      status
      statusLabel
      currentStep
      targetEmail
      fundId
      metadata
      expiresAt
      createdAt
      updatedAt
    }
  }
`

export const advisorInviteContext = gql`
  query advisorInviteContext($token: String!) {
    advisorInviteContext(token: $token) {
      targetEmail
      donorName
      amount
      custodianName
      advisorName
      advisorPhone
      advisorDealerRepCode
      targetAlreadyClaimed
    }
  }
`
